import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';
import styles from './AnnouncementBanner.module.scss';

/**
 * How the announcement banner looks, without any of its behaviour. Used by
 * AnnouncementBanner and by the Backstage preview.
 */
const AnnouncementBannerView = ({
  announcement,
  onSecondaryClick,
  onCtaClick,
  onDismiss,
}) => {
  const banner = announcement.banner;

  if (!banner) {
    return null;
  }

  // Tier 1 uses a button; Tier 2 and 3 use a text link
  const isLaunch = announcement.tier === 1;

  return (
    <div className={styles.banner} role="region" aria-label="Announcement">
      <div className={styles.inner}>
        <p className={styles.text}>
          <strong className={styles.headline}>{banner.headline}</strong>
          {banner.line && <span className={styles.line}>{banner.line}</span>}
        </p>
        <div className={styles.actions}>
          {banner.secondary_url && (
            <a
              href={banner.secondary_url}
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onSecondaryClick}
            >
              {banner.secondary_label}
            </a>
          )}
          {banner.cta_url && (
            <a
              href={banner.cta_url}
              className={isLaunch ? styles.button : styles.link}
              onClick={onCtaClick}
            >
              {banner.cta_label}
            </a>
          )}
          <button
            type="button"
            className={styles.close}
            onClick={onDismiss}
            aria-label="Dismiss"
          >
            <X size={18} aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};

AnnouncementBannerView.propTypes = {
  announcement: PropTypes.shape({
    tier: PropTypes.number,
    banner: PropTypes.shape({
      headline: PropTypes.string,
      line: PropTypes.string,
      cta_label: PropTypes.string,
      cta_url: PropTypes.string,
      secondary_label: PropTypes.string,
      secondary_url: PropTypes.string,
    }),
  }).isRequired,
  onSecondaryClick: PropTypes.func,
  onCtaClick: PropTypes.func,
  onDismiss: PropTypes.func,
};

AnnouncementBannerView.defaultProps = {
  onSecondaryClick: undefined,
  onCtaClick: undefined,
  onDismiss: undefined,
};

export default AnnouncementBannerView;
